import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import store from './store'
import  ElementUI from 'element-ui'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'element-ui/lib/theme-chalk/index.css'
import BaiduMap from 'vue-baidu-map';
import {Icon} from 'vant';
import "video.js/dist/video-js.css";


Vue.use(Mint);
Vue.use(ElementUI);
Vue.use(Icon);

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: '3YOCg7ZoHfhOLxtsTDpMVuPs'
});
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
